const prefix = 'valzum_permission_';

export function storedPermissionState(key) {
    try {
        return localStorage.getItem(prefix + key) || 'prompt';
    } catch (error) {
        return 'prompt';
    }
}

export function rememberPermissionState(key, state) {
    if (!state) {
        return;
    }

    try {
        localStorage.setItem(prefix + key, state);
    } catch (error) {}
}

export async function queryBrowserPermission(name, key = name) {
    const stored = storedPermissionState(key);

    if (!navigator.permissions || typeof navigator.permissions.query !== 'function') {
        return stored;
    }

    try {
        const permission = await navigator.permissions.query({name});
        rememberPermissionState(key, permission.state);

        if (typeof permission.addEventListener === 'function') {
            permission.addEventListener('change', () => rememberPermissionState(key, permission.state));
        } else {
            permission.onchange = () => rememberPermissionState(key, permission.state);
        }

        return permission.state;
    } catch (error) {
        return stored;
    }
}

export function currentNotificationPermission() {
    if (typeof Notification === 'undefined') {
        return storedPermissionState('notifications');
    }

    const permission = Notification.permission === 'default' ? 'prompt' : Notification.permission;
    rememberPermissionState('notifications', permission);

    return permission;
}
